import { useQuery } from '@tanstack/react-query';
import api from '../axios';

export const useProjectsQuery = (min: boolean) => {
    return useQuery({
        queryKey: ['projects', min],
        queryFn: async ({ queryKey }: { queryKey: [string, boolean] }) => {
            const [, min] = queryKey;
            try {
                const response = await api.get(`/projects?mine=${min}`);
                return response;
            } catch (error) {
                throw error;
            }
        },
    });
};
